import type { CompanyInvoice } from '@mobiletract/account-service-angular-client';

export function isCompanyInvoiceFilled(invoice?: CompanyInvoice | null): boolean {
  const companyName = invoice?.companyName?.trim();
  const nip = String(invoice?.nipNumber ?? '').trim();
  return Boolean(companyName && nip);
}
